import {regex, minLength, maxLength, number, required} from "admin-on-rest";

const isASCII = str => {
  return /^[A-z0-9]*$/.test(str);
};

const hasCharacter = str => {
  return /[A-Za-z]+/.test(str);
};

const checkMandatoryData = (errors, values, {translate}) => {
  if (!values.partner_id || values.partner_id.trim() === "") {
    errors.partner_id = translate("resources.stores.validation.storeOwner");
  }
  if (!values.name || values.name.trim() === "") {
    errors.name = translate("resources.stores.validation.storeName");
  }
  if (!values.sms_sender) {
    errors.sms_sender = translate("resources.stores.validation.sender");
  } else if (!isASCII(values.sms_sender)) {
    errors.sms_sender = translate("resources.stores.validation.senderASCII");
  } else if (!hasCharacter(values.sms_sender)) {
    errors.sms_sender = translate(
      "resources.stores.validation.senderCharacter"
    );
  }

  if (!values.email || values.email.trim() === "") {
    errors.email = translate("resources.stores.validation.email");
  }
};

const checkIfPhoneIsRequired = (errors, values, {translate}) => {
  if (!values.phone || values.phone.trim() === "") {
    errors.phone = translate("resources.stores.validation.phone");
  }
};

const isWorkingHoursValid = (
  values,
  attributeName,
  workingHoursType,
  workingHoursPoint
) => {
  return (
    values[attributeName] &&
    values[attributeName][workingHoursType] &&
    values[attributeName][workingHoursType][workingHoursPoint]
  );
};

const isLocationAddressValid = (values, attributeName, name) => {
  if (values && values[attributeName] && values[attributeName][name])
    return (
      values[attributeName] &&
      values[attributeName][name] &&
      values[attributeName][name].trim() !== ""
    );
};

const checkIfWebInfoIsRequired = (errors, values, {translate}) => {
  if (!values.headline || values.headline.trim() === "") {
    errors.headline = translate("resources.stores.validation.headline");
  }
  if (!values.about || values.about.trim() === "") {
    errors.about = translate("resources.stores.validation.about");
  }

  if (!isLocationAddressValid(values, "location", "address")) {
    errors.location = translate("resources.stores.validation.address");
  }

  if (!isWorkingHoursValid(values, "working_hours", "regular", "start")) {
    errors.working_hours = errors.working_hours || {};
    errors.working_hours.regular = errors.working_hours.regular || {};
    errors.working_hours.regular.start = translate(
      "resources.stores.validation.workingHours.regular.start"
    );
  }

  if (!isWorkingHoursValid(values, "working_hours", "regular", "end")) {
    errors.working_hours = errors.working_hours || {};
    errors.working_hours.regular = errors.working_hours.regular || {};
    errors.working_hours.regular.end = translate(
      "resources.stores.validation.workingHours.regular.end"
    );
  }
  if (!isWorkingHoursValid(values, "working_hours", "other", "start")) {
    errors.working_hours = errors.working_hours || {};
    errors.working_hours.other = errors.working_hours.other || {};
    errors.working_hours.other.start = translate(
      "resources.stores.validation.workingHours.other.start"
    );
  }
  if (!isWorkingHoursValid(values, "working_hours", "other", "end")) {
    errors.working_hours = errors.working_hours || {};
    errors.working_hours.other = errors.working_hours.other || {};
    errors.working_hours.other.end = translate(
      "resources.stores.validation.workingHours.other.end"
    );
  }
};

export const validateStoreData = (values, {translate}) => {
  const errors = {};

  checkMandatoryData(errors, values, {translate});
  checkIfPhoneIsRequired(errors, values, {translate});
  checkIfWebInfoIsRequired(errors, values, {translate});
  return errors;
};

export const validateStoreMandatoryData = (values, {translate}) => {
  const errors = {};
  checkMandatoryData(errors, values, {translate});
  return errors;
};

export const validateWithoutWebInformation = (values, {translate}) => {
  const errors = {};
  checkMandatoryData(errors, values, {translate});
  checkIfPhoneIsRequired(errors, values, {translate});
  return errors;
};

export const validateWithoutPhone = (values, {translate}) => {
  const errors = {};
  checkMandatoryData(errors, values, {translate});
  checkIfWebInfoIsRequired(errors, values, {translate});
  return errors;
};

const storeUrlPattern = regex(
  /^[a-zA-Z0-9_-]*$/,
  "resources.stores.validation.storeUrlPattern"
);

const URLPattern = regex(
  /^(ftp|http|https):\/\/www.facebook.com\/[^ "]+$/,
  "resources.stores.validation.storeUrlPattern"
);

export const validateStoreUrl = [required, storeUrlPattern];
export const validateFacebookPage = [URLPattern];
export const validatePhone = [number, minLength(10)];
export const validateAbout = [maxLength(255)];
export const validateHeadline = [maxLength(120)];
export const validateSender = [minLength(3), maxLength(11)];
export const validateMarketingPartnerID = [maxLength(120)];
export const validateCustomerNumber = [number, minLength(6), maxLength(6)];



// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/validations.js